import { useIntl } from 'react-intl'
import TextButton from 'LuxKit/Button/TextButton'

interface Props {
  hidden?: boolean
}

function LeLiveGetTicketsButton({ hidden }: Props) {
  const intl = useIntl()

  if (hidden) return null

  return (
    <TextButton
      kind="primary"
      size="large"
      fit="mobile-full-width"
      to="/live#registration"
    >
      {intl.formatMessage({
        id: 'PJwwS7gZOCK0cNexjnVv',
        defaultMessage: 'Get tickets',
        description: 'Call-to-action button that scrolls to the ticket registration section on the LE Live event page',
      })}
    </TextButton>
  )
}

export default LeLiveGetTicketsButton
